module.exports = __webpack_public_path__ + "img/juca_immenstadt.905e63d3.png";